import { useMemo } from 'react';

import get from 'lodash/get';
import useSWR from 'swr';

import { getVolumeList } from '../api';
import type { UseExistingVolumeOptionsParams } from '../types';
import type { ExistingVolumeOptionItem } from '../types';
import { mapExistingVolumeItems } from '../utils';

export function useExistingVolumeOptions({ namespace, volumeType, enabled = true }: UseExistingVolumeOptionsParams) {
  const swrKey = enabled
    ? {
        key: 'EXISTING_VOLUME_OPTIONS',
        namespace: namespace ?? null,
        volumeType,
      }
    : null;

  const { data, isLoading } = useSWR(
    swrKey,
    ({ namespace: ns, volumeType: type }) =>
      getVolumeList({
        limit: -1,
        ...(ns ? { namespace: ns } : {}),
        type,
        status: 'Available',
      }),
    { revalidateOnFocus: false, refreshInterval: 15_000 },
  );

  const options = useMemo<ExistingVolumeOptionItem[]>(() => {
    if (!data) return [];
    return mapExistingVolumeItems(get(data, 'items', []));
  }, [data]);

  return { options, isLoading };
}
